import config from "config";
import BaseDataProvider from "./BaseDataProvider";
import axios from "axios";
import _ from "lodash";
import { AuthDriver as auth } from "auth";

class NewsgateTransformsDataProvider extends BaseDataProvider {
  async getList(resource, params) {
    const transformEndpoint = config("backend.sendToNewsgateUri");
    try {
      const currentUser = await auth.getCurrentUser();
      const jwtAccessToken = _.get(currentUser, "session.accessToken.jwtToken");
      const response = await axios.get(transformEndpoint + "/transforms", {
        headers: { Authorization: `Bearer ${jwtAccessToken}` }
      });
      return {
        data: _.map(response.data, (d) => ({ id: d, name: d })),
        total: response.data.length
      };
    } catch (err) {
      console.error(err);
      return null;
    }
  }

  async sendToNewsgate(resource, params) {
    function fixup(date) {
      if (!date) return "";
      if (date.length === 10) return date + "T05:00:00Z";
      return date;
    }

    const transformEndpoint = config("backend.sendToNewsgateUri");
    try {
      const currentUser = await auth.getCurrentUser();
      const jwtAccessToken = _.get(currentUser, "session.accessToken.jwtToken");
      const response = await axios.post(
        transformEndpoint +
          "/transforms/" +
          params.id +
          "/queryTransformUpload",
        null,
        {
          headers: { Authorization: `Bearer ${jwtAccessToken}` },
          params: {
            season_code: params.seasonCode,
            start_date: fixup(params.startDate),
            end_date: fixup(params.endDate)
          }
        }
      );
      return { data: response.data };
    } catch (err) {
      console.error(err);
      return null;
    }
  }
}

export default NewsgateTransformsDataProvider;
